import { Resolvers } from '@apollo/client/core';

import { gql } from 'apollo-angular';

import Utils from '@app/shared/utils';

export interface SubscriptionBasic {
  subscriptionId: string;
  name: string;
  msrpTotal: number;
  total: number;
  intervalMonths: number;
  next: Date;
  start: Date;
  end?: Date;
  sourceOrderId: string;
  status: SubscriptionStatus;
  insertedByUserFullName: string;
  updatedByUserFullName: string;
  insertedDate: Date;
  updatedDate: Date;
  cancellationNote: string;
  lastBillDate?: Date;
  renewable: boolean;
  intervals: any;
  items: any;
}

export type SubscriptionStatus = 'Pending' | 'Started' | 'Ended' | 'Canceled';

export const SubscriptionBasicFragment = gql`
  fragment SubscriptionBasic on Subscription {
    subscriptionId
    name
    msrpTotal
    total
    intervalMonths
    next
    start
    end
    sourceOrderId
		status
    insertedByUserFullName
    updatedByUserFullName
    insertedDate
    updatedDate
    cancellationNote
    lastBillDate @client
    renewable @client
    #for resolvers
    intervals {
      intervalDate
    }
    items {
      sourceProduct {
        isActive
      }
      sourceProductId
    }
  }
`;

interface SubscriptionQuery extends SubscriptionBasic {
  intervals: {
    intervalDate: Date
  }[];
  items: {
    sourceProduct: { isActive: boolean }
    sourceProductId: string
  }[];
}

export const SubscriptionBasicResolver: Resolvers = {
  Subscription: {
    renewable: (parent: SubscriptionQuery) => {
      const renewable = parent.items &&
        parent.items.length &&
        parent.items.map(item => item.sourceProduct).every(product => product.isActive);
      return renewable;
    },
    end: (parent: SubscriptionQuery) => parent.end && new Date(Utils.utcDate(parent.end.toString())),
    start: (parent: SubscriptionQuery) => Utils.utcDate(parent.start.toString()),
    next: (parent: SubscriptionQuery) => parent.next && Utils.utcDate(parent.next.toString()),
    lastBillDate: (parent: SubscriptionQuery) => {
      return (parent.intervals && parent.intervals.length > 0) ?
        Utils.utcDate(parent.intervals[parent.intervals.length - 1].intervalDate.toString()) : null;
    }
  }
};
